import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import {
  faCheckSquare,
  faCircle,
  faPause,
  faStop,
  faPauseCircle,
  faLayerPlus,
  faLayerGroup,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarTimes,
  faCalendarEdit,
  faNetworkWired,
  faCopy,
  faClone,
  faEdit,
  faPen,
  faTrash,
  faUser,
  faFileSpreadsheet,
  faSortDown,
  faSortUp,
  faTimes,
  faPhone,
  faMinusSquare,
  faPlusSquare,
  faFileCertificate,
  faColumns,
  faList,
  faUserPlus,
  faChevronDown,
  faComment,
  faCommentPlus,
  faCommentDots,
  faPhoneSquare,
  faExclamationTriangle,
  faTag
} from '@fortawesome/pro-regular-svg-icons';

library.add(
  fab,
  fas,
  far,
  fal,
  faCheckSquare,
  faCircle,
  faPause,
  faStop,
  faLayerPlus,
  faPauseCircle,
  faLayerGroup,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarTimes,
  faCalendarEdit,
  faNetworkWired,
  faCopy,
  faClone,
  faEdit,
  faPen,
  faTrash,
  faUser,
  faFileSpreadsheet,
  faSortDown,
  faSortUp,
  faTimes,
  faPhone,
  faMinusSquare,
  faPlusSquare,
  faFileCertificate,
  faColumns,
  faList,
  faUserPlus,
  faChevronDown,
  faComment,
  faCommentPlus,
  faCommentDots,
  faPhoneSquare,
  faExclamationTriangle,
  faTag
)